import axios from "axios";
import Swal from "sweetalert2";

export const safeValue = (value, defaultValue = "") => {
  if (value === null || value === undefined || value === "") {
    return defaultValue;
  }
  // ✅ Convertir a string para comparaciones consistentes
  return value.toString();
};

// ✅ Nueva función para valores de radio buttons
export const safeRadioValue = (value, defaultValue = "1") => {
  if (value === null || value === undefined || value === "") {
    return defaultValue;
  }
  // Asegurar que sea string para los radio buttons
  return value.toString();
};

// Función para verificar si un valor existe (no null, undefined, o string vacío)
export const hasValue = (value) => {
  return value !== null && value !== undefined && value !== "";
};

// Función para verificar checkboxes basados en valores existentes
export const isChecked = (value) => {
  return hasValue(value) && value !== "0" && value !== "false";
};

export const saveReceptionData = async (formData, master, subproduct, user) => {
  try {
    console.log("📤 Iniciando envío de datos al backend...");
    console.log("📊 FormData recibido:", formData);

    // ✅ CORREGIDO: Usar números en lugar de strings
    const payload = {
      id_master: master.resp?.master_id || master.master?.id,
      id_house: subproduct?.id || null,
      user_id: user?.id || 1,
      preve_save: master.preve_save?.id || null,

      // ✅ CORREGIDO: Usar números para campos booleanos
      master_awb: formData.master_awb ? 1 : 0,
      master_awb_e: formData.master_eawb ? 1 : 0,
      house_manifest: subproduct ? (formData.house_manifest ? 1 : 0) : null,
      simplified_request: formData.simplified_request ? 1 : 0,
      cargo_transfer: formData.cargo_transfer ? 1 : 0,
      security_letter: formData.security_letter ? 1 : 0,
      acceptance_letter: formData.acceptance_letter ? 1 : 0,
      custom_badge: formData.custom_badge ? 1 : 0,
      required_temp: formData.required_temp || "N/A",

      // ✅ CORREGIDO: Campos de naturaleza (usar números)
      nat_cgo: formData.nat_cgo ? 1 : 0,
      nat_cgo_pieces: formData.nat_cgo_pieces || null,
      nat_cgo_weight: formData.nat_cgo_weight || null,

      nat_dgr: formData.nat_dgr ? 1 : 0,
      nat_dgr_pieces: formData.nat_dgr_pieces || null,
      nat_dgr_weight: formData.nat_dgr_weight || null,

      nat_per: formData.nat_per ? 1 : 0,
      nat_per_pieces: formData.nat_per_pieces || null,
      nat_per_weight: formData.nat_per_weight || null,

      nat_avi: formData.nat_avi ? 1 : 0,
      nat_avi_pieces: formData.nat_avi_pieces || null,
      nat_avi_weight: formData.nat_avi_weight || null,

      nat_val: formData.nat_val ? 1 : 0,
      nat_val_pieces: formData.nat_val_pieces || null,
      nat_val_weight: formData.nat_val_weight || null,

      nat_hum: formData.nat_hum ? 1 : 0,
      nat_hum_pieces: formData.nat_hum_pieces || null,
      nat_hum_weight: formData.nat_hum_weight || null,

      nat_dip: formData.nat_dip ? 1 : 0,
      nat_dip_pieces: formData.nat_dip_pieces || null,
      nat_dip_weight: formData.nat_dip_weight || null,

      nat_nwp: formData.nat_nwp ? 1 : 0,
      nat_nwp_pieces: formData.nat_nwp_pieces || null,
      nat_nwp_weight: formData.nat_nwp_weight || null,

      nat_mal: formData.nat_mal ? 1 : 0,
      nat_mal_pieces: formData.nat_mal_pieces || null,
      nat_mal_weight: formData.nat_mal_weight || null,

      nat_com: formData.nat_com ? 1 : 0,
      nat_com_pieces: formData.nat_com_pieces || null,
      nat_com_weight: formData.nat_com_weight || null,

      nat_vic: formData.nat_vic ? 1 : 0,
      nat_vic_pieces: formData.nat_vic_pieces || null,
      nat_vic_weight: formData.nat_vic_weight || null,

      nat_pil: formData.nat_pil ? 1 : 0,
      nat_pil_pieces: formData.nat_pil_pieces || null,
      nat_pil_weight: formData.nat_pil_weight || null,

      // ✅ CORREGIDO: Campos de manejo (usar números)
      han_ice: formData.han_ice ? 1 : 0,
      han_ice_pieces: formData.han_ice_pieces || null,
      han_ice_weight: formData.han_ice_weight || null,

      han_wet: formData.han_wet ? 1 : 0,
      han_wet_pieces: formData.han_wet_pieces || null,
      han_wet_weight: formData.han_wet_weight || null,

      han_big: formData.han_big ? 1 : 0,
      han_big_pieces: formData.han_big_pieces || null,
      han_big_weight: formData.han_big_weight || null,

      han_hea: formData.han_hea ? 1 : 0,
      han_hea_pieces: formData.han_hea_pieces || null,
      han_hea_weight: formData.han_hea_weight || null,

      han_hwc: formData.han_hwc ? 1 : 0,
      han_hwc_pieces: formData.han_hwc_pieces || null,
      han_hwc_weight: formData.han_hwc_weight || null,

      han_col: formData.han_col ? 1 : 0,
      han_col_pieces: formData.han_col_pieces || null,
      han_col_weight: formData.han_col_weight || null,

      han_fro: formData.han_fro ? 1 : 0,
      han_fro_pieces: formData.han_fro_pieces || null,
      han_fro_weight: formData.han_fro_weight || null,

      han_na: formData.han_na ? 1 : 0,
      han_na_pieces: formData.han_na_pieces || null,
      han_na_weight: formData.han_na_weight || null,

      // ✅ CORREGIDO: Entregas adicionales (usar números/strings según corresponda)
      has_acas: formData.has_acas ? "1" : "0",
      special_cargo: formData.specialLoads ? "1" : "0",
      ata_sat_office: formData.ata_sat_office ? "1" : "0",
      interlineal_cargo: formData.interlineLoads ? "1" : "0",
      intcar_transfer: formData.intcar_transfer ? "1" : "0",
      perishables: formData.nat_per ? "1" : "0",
      perishables_certified: formData.perishables_certified ? "1" : "0",
      dangerous_goods: formData.nat_dgr ? "1" : "0",
      dg: formData.dg ? "1" : "0",
      live_animals: formData.nat_avi ? "1" : "0",
      shipper_certified: formData.shipper_certified ? "1" : "0",
      human_remains: formData.nat_hum ? "1" : "0",
      hr_cert: formData.hr_cert ? "1" : "0",
      hr_permission_transfer: formData.hr_permission_transfer ? "1" : "0",
      hr_permission: formData.hr_permission ? "1" : "0",
      un_dg: formData.un_dg || null,
      has_dg_exempt: formData.has_dg_exempt || null,

      // ✅ CORREGIDO: Contenedores activos
      "c-NoRKN": formData.contActivos_RKN
        ? formData.contActivos_RKN_number
        : null,
      "c-NoRAP": formData.contActivos_RAP
        ? formData.contActivos_RAP_number
        : null,
      "p-NoRKN": formData.prepContenedor_RKN
        ? formData.prepContenedor_RKN_number
        : null,
      "p-NoRAP": formData.prepContenedor_RAP
        ? formData.prepContenedor_RAP_number
        : null,
    };

    console.log("📦 Payload construido:", payload);

    // ✅ Booking flights (mantener igual)
    const boobking_id_col = [];
    const boobking_pieces_col = [];
    const boobking_weight_col = [];
    const boobking_id_fro = [];
    const boobking_pieces_fro = [];
    const boobking_weight_fro = [];

    if (master.booking_flights && master.booking_flights.length > 0) {
      master.booking_flights.forEach((flight, index) => {
        const colPieces = formData[`flights_col_pieces_${index}`];
        const colWeight = formData[`flights_col_weight_${index}`];
        const froPieces = formData[`flights_fro_pieces_${index}`];
        const froWeight = formData[`flights_fro_weight_${index}`];

        if (colPieces !== undefined && colWeight !== undefined) {
          boobking_id_col.push(flight.id);
          boobking_pieces_col.push(colPieces.toString());
          boobking_weight_col.push(colWeight.toString());
        }

        if (froPieces !== undefined && froWeight !== undefined) {
          boobking_id_fro.push(flight.id);
          boobking_pieces_fro.push(froPieces.toString());
          boobking_weight_fro.push(froWeight.toString());
        }
      });
    }

    if (boobking_id_col.length > 0) {
      payload.boobking_id_col = boobking_id_col;
      payload.boobking_pieces_col = boobking_pieces_col;
      payload.boobking_weight_col = boobking_weight_col;
    }

    if (boobking_id_fro.length > 0) {
      payload.boobking_id_fro = boobking_id_fro;
      payload.boobking_pieces_fro = boobking_pieces_fro;
      payload.boobking_weight_fro = boobking_weight_fro;
    }

    console.log("✈️ Booking data:", {
      col: {
        ids: boobking_id_col,
        pieces: boobking_pieces_col,
        weights: boobking_weight_col,
      },
      fro: {
        ids: boobking_id_fro,
        pieces: boobking_pieces_fro,
        weights: boobking_weight_fro,
      },
    });

    // ✅ Enviar al backend
    const response = await axios.post(
      `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/save`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.code === 0) {
      Swal.fire({
        title: "Éxito",
        text: response.data.message || "Datos guardados correctamente",
        icon: "success",
        confirmButtonText: "Aceptar",
      });

      return response.data;
    } else {
      throw new Error(response.data.error || "Error al guardar los datos");
    }
  } catch (error) {
    console.error("❌ Error saving reception data:", error);
    console.error("❌ Error response:", error.response?.data);

    Swal.fire({
      title: "Error",
      text:
        error.response?.data?.error ||
        error.message ||
        "Error al guardar los datos",
      icon: "error",
      confirmButtonText: "Aceptar",
    });

    throw error;
  }
};
